export default {
    androidTitle: 'Android SDK',
    iosTitle: 'IOS SDK',
    btn: '下载SDK'
};
